import template from './editProfile.html';
import controller from './editProfile.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '=',
  },
};

export default component;
